import React, { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { Button, Collapse, IconButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import homeIcon from "../assets/icon/home.png";
import solutions from "../assets/icon/solutions.png";
import Industries from "../assets/icon/Industries.png";
// import code from "../assets/icon/code.png";
import contact from "../assets/icon/contact.png";
import pricing from "../assets/icon/pricing.png";
// import Search from "../assets/search.svg";
import User from "../assets/user.svg";
import RightIcon from "@mui/icons-material/ChevronRightRounded";
import { useLocation, useNavigate } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  link: {
    padding: "10px 20px",
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "2.04px",

    textDecoration: "none",
    color: theme.palette.info.contrastText,
  },
  link_active: {
    background: theme.palette.secondary.main,
  },
  icon_wrapper: {
    display: "flex",
    gap: "10px",
    justifyContent: "space-between",
    padding: "10px",
  },
}));

// type Anchor = "top" | "left" | "bottom" | "right";

export default function MobileNavbar() {
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  //   const toggleDrawer =
  //     (anchor: Anchor, open: boolean) =>
  //     (event: React.KeyboardEvent | React.MouseEvent) => {
  //       if (
  //         event.type === "keydown" &&
  //         ((event as React.KeyboardEvent).key === "Tab" ||
  //           (event as React.KeyboardEvent).key === "Shift")
  //       ) {
  //         return;
  //       }

  //       setState({ ...state, [anchor]: open });
  //     };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const theme = useTheme();

  const classes = useStyles();
  const navigate = useNavigate();

  const pathname = useLocation().pathname;

  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [industriesOpen, setIndustriesOpen] = useState(false);

  const handleSolutionsOpen = () => {
    setSolutionsOpen(!solutionsOpen);
    setIndustriesOpen(false);
  };
  const handleIndustriesOpen = () => {
    setIndustriesOpen(!industriesOpen);
    setSolutionsOpen(false);
  };
  const redirectToWebsite = (url) => {
    window.location.href = url; // Replace with the desired URL
  };
  return (
    <div>
      <React.Fragment>
        <IconButton onClick={toggleDrawer("left", true)}>
          <MenuIcon sx={{ fontSize: "30px" }} />
        </IconButton>

        <Drawer
          anchor="left"
          open={state["left"]}
          onClose={toggleDrawer("left", false)}
        >
          <Box
            sx={{
              width: 270,
              background: "#e7fffd",
              minHeight: "100vh",
            }}
            role="presentation"
            // onClick={toggleDrawer("left", false)}
            onKeyDown={toggleDrawer("left", false)}
          >
            <List>
              <ListItemButton
                onClick={() => {
                  //   navigate("/");
                  redirectToWebsite(process.env.REACT_APP_WEBSITE_URL);
                }}
                onMouseDown={toggleDrawer("left", false)}
                className={
                  pathname === process.env.REACT_APP_WEBSITE_URL
                    ? classes.link_active
                    : ""
                }
              >
                <ListItemIcon>
                  <img src={homeIcon} alt="" />
                </ListItemIcon>
                <ListItemText primary="Home" />
              </ListItemButton>
              <ListItemButton onClick={handleSolutionsOpen}>
                <ListItemIcon>
                  <img src={solutions} alt="" />
                </ListItemIcon>
                <ListItemText primary="Solutions" />
                {solutionsOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>

              <Collapse
                in={solutionsOpen}
                timeout="auto"
                unmountOnExit
                style={{ background: "#fff" }}
              >
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/kyc-compliance");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/kyc-compliance`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/kyc-compliance" ? classes.link_active : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="KYC Compliance" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/id-document-verification");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/id-document-verification`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/id-document-verification"
                        ? classes.link_active
                        : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="ID Document Verification" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/customer-onboarding");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/customer-onboarding`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/customer-onboarding"
                        ? classes.link_active
                        : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Customer Onboarding" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/kyc-flow-builder");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/kyc-flow-builder`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/kyc-flow-builder"
                        ? classes.link_active
                        : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="KYC Flow Builder" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/proof-of-address");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/proof-of-address`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/proof-of-address"
                        ? classes.link_active
                        : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Proof of Address" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/age-verification");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/age-verification`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/age-verification"
                        ? classes.link_active
                        : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Age Verification" />
                  </ListItemButton>
                </List>
              </Collapse>

              <ListItemButton onClick={handleIndustriesOpen}>
                <ListItemIcon>
                  <img src={Industries} alt="" />
                </ListItemIcon>
                <ListItemText primary="Industries" />
                {industriesOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
              <Collapse
                in={industriesOpen}
                timeout="auto"
                unmountOnExit
                style={{ background: "#fff" }}
              >
                <List component="div" disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/financial-services");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/financial-services`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/financial-services"
                        ? classes.link_active
                        : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Financial Services" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/crypto");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/crypto`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/crypto" ? classes.link_active : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Crypto" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/gaming-and-e-sports");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/gaming-and-e-sports`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/gaming-and-e-sports"
                        ? classes.link_active
                        : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Gaming and E-sports" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/legal-industry");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/legal-industry`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/legal-industry" ? classes.link_active : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Legal Industry" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/healthcare");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/healthcare`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/healthcare" ? classes.link_active : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Healthcare" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => {
                      //   navigate("/marketplaces");
                      redirectToWebsite(
                        `${process.env.REACT_APP_WEBSITE_URL}/marketplaces`
                      );
                    }}
                    onMouseDown={toggleDrawer("left", false)}
                    className={
                      pathname === "/marketplaces" ? classes.link_active : ""
                    }
                  >
                    <ListItemIcon>
                      <RightIcon />
                    </ListItemIcon>
                    <ListItemText primary="Marketplaces" />
                  </ListItemButton>
                </List>
              </Collapse>
              <ListItemButton
                onClick={() => {
                  //   navigate("/pricing");
                  redirectToWebsite(
                    `${process.env.REACT_APP_WEBSITE_URL}/pricing`
                  );
                }}
                onMouseDown={toggleDrawer("left", false)}
                className={pathname === "/pricing" ? classes.link_active : ""}
              >
                <ListItemIcon>
                  <img src={pricing} alt="" />
                </ListItemIcon>
                <ListItemText primary="Pricing" />
              </ListItemButton>
              {/* <ListItemButton
                onClick={() => {
                  navigate("/developers");
                }}
                onMouseDown={toggleDrawer("left", false)}
                className={
                  pathname === "/developers" ? classes.link_active : ""
                }
              >
                <ListItemIcon>
                  <img src={code} alt="" />
                </ListItemIcon>
                <ListItemText primary="Developers" />
              </ListItemButton> */}
              <ListItemButton
                onClick={() => {
                  //   navigate("/contact-us");
                  redirectToWebsite(
                    `${process.env.REACT_APP_WEBSITE_URL}/contact-us`
                  );
                }}
                onMouseDown={toggleDrawer("left", false)}
                className={
                  pathname === "/contact-us" ? classes.link_active : ""
                }
              >
                <ListItemIcon>
                  <img src={contact} alt="" />
                </ListItemIcon>
                <ListItemText primary="Contact Us" />
              </ListItemButton>
            </List>
            <Box
              sx={{
                position: "absolute",
                left: 0,
                bottom: 0,
                width: "100%",
              }}
            >
              <Box className={classes.icon_wrapper}>
                {/* <Box>
                  <Button
                    variant="outlined"
                    sx={{ py: 1, px: 2, display: "flex", gap: 1 }}
                  >
                    <img src={Search} alt="" /> Search
                  </Button>
                </Box> */}

                <Button
                  fullWidth
                  variant="outlined"
                  sx={{
                    py: 1,
                    px: 2,
                    display: "flex",
                    gap: 1,
                    borderRadius: "7px",
                  }}
                  onClick={() => {
                    // navigate("/login");
                    redirectToWebsite("https://console.certifymyid.com/");
                  }}
                  onMouseDown={toggleDrawer("left", false)}
                >
                  <img src={User} alt="" /> Account
                </Button>
              </Box>
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
    </div>
  );
}
